import { fetchEndpoint } from '../server/network'

// 热门关键词
export const searchKeywordList = () => fetchEndpoint('/v2/ecapi.search.keyword.list', 'POST')

// 文章列表
export const articleList = (data) => fetchEndpoint('/v2/ecapi.article.list', 'POST', data)

//文章详情
export const articleInfo = (data) => fetchEndpoint('/v2/ecapi.article.info', 'POST', data)

//技术服务列表
export const technicalList = (data) =>fetchEndpoint('/v2/ecapi.technical.services.list', 'POST', data)

//技术服务详情
export const technicalInfo = (data) => fetchEndpoint('/v2/ecapi.technical.services.get', 'POST', data)

export const configGet = () => fetchEndpoint('/v2/ecapi.config.get', 'POST')

// 获取发票类型列表
export const invoiceTypeList = () => fetchEndpoint('/v2/ecapi.invoice.type.list', 'POST')

// 获取发票内容列表
export const invoiceContentList = () =>	fetchEndpoint('/v2/ecapi.invoice.content.list', 'POST')

// 获取发票状态（是否提供发票）
export const invoiceStatusGet = () =>	fetchEndpoint('/v2/ecapi.invoice.status.get', 'POST')

// 货运公司列表
export const shippingVendorList = (data) => fetchEndpoint('/v2/ecapi.shipping.vendor.list', 'POST', data)

// 物流状态查询 ECM4.0
export const shippingStatusGet = (data) => fetchEndpoint('/v2/ecapi.shipping.status.get', 'POST', data)

// 站点信息
export const siteGet = () => fetchEndpoint('/v2/ecapi.site.get', 'POST')

//产品定制列表
export const customServiceList = (data) => fetchEndpoint('/v2/custom.service.list', 'POST', data)

//产品定制详情
export const customServiceInfo = (data) => fetchEndpoint('/v2/custom.service.info', 'POST', data)

//定制撤销
export const customServiceCancel = (data) => fetchEndpoint('/v2/custom.service.cancel', 'POST', data)

//定制签字确认
export const customServiceSign = (data) => fetchEndpoint('/v2/custom.service.sign', 'POST', data)

//统计扫描二维码进入的次数
export const scanCodeCount = (data) => fetchEndpoint('/v2/scan.code.count', 'POST', data)

// 获取红包列表 ECMobile 4.0
export const cashgiftList = (data) => fetchEndpoint('/v2/ecapi.cashgift.list', 'POST', data)







//购物车添加
export const cartToAdd = (data) => fetchEndpoint('/v2/cart/add-to-cart', 'POST', data)

//购物车数量
export const cartCount = () => fetchEndpoint('/v2/cart/count', 'POST')

//套餐价格
export const comboPrice = (data) => fetchEndpoint('/v2/cart/combo-price', 'POST', data)

//套餐加入购物车
export const comboAddToCart = (data) => fetchEndpoint('/v2/cart/add-combo-to-cart', 'POST', data)

// 重选套餐
export const reelectPackage = (data) => fetchEndpoint('/v2/cart/reselect-package', 'POST', data)

//购物车列表
export const cartList = (data) => fetchEndpoint('/v2/cart/list', 'POST', data)

//修改购物车产品数量
export const cartUpdateGoodsNumber = (data) => fetchEndpoint('/v2/cart/update-goods-number', 'POST', data)

//删除购物车产品
export const cartDeleteProduct = (data) => fetchEndpoint('/v2/cart/delete-product', 'POST', data)

//收藏购物车产品
export const cartCollectProduct = (data) => fetchEndpoint('/v2/ecapi.collect.get', 'POST', data)

//购物车产品价格计算
export const cartPrice = (data) => fetchEndpoint('/v2/cart/price', 'POST', data)

//订单结算页
export const orderConfirmInfo = (data) => fetchEndpoint('/v2/order/confirm-info', 'POST', data)

//订单价格计算
export const orderPrice = (data) => fetchEndpoint('/v2/cart/price', 'POST', data)

// 订单支付
export const paymentPay = (order, code, referer, channel, openid) =>
	fetchEndpoint('/v2/ecapi.payment.pay', 'POST', {
		order: order, // 订单ID
		code: code, // 支付code  ehking 易汇金 pay.alipay 支付宝支付    pay.weixin微信支付  pay.unionpay 银联支付   pay.code 货到付款 pay.teegon  天工
		referer: referer, // 支付code  ehking 易汇金 pay.alipay 支付宝支付    pay.weixin微信支付  pay.unionpay 银联支付   pay.code 货到付款 pay.teegon  天工
		channel: channel, // 支付code  ehking 易汇金 pay.alipay 支付宝支付    pay.weixin微信支付  pay.unionpay 银联支付   pay.code 货到付款 pay.teegon  天工
		openid: openid
	})


//红包列表
export const getRedPacketList = (data) => fetchEndpoint('/v2/order/bonus', 'POST', data)

//验证券码
export const orderVerifyCouponCode = (data) => fetchEndpoint('/v2/order/verify-coupon-code', 'POST', data)

//提交订单
export const orderCreate = (data) => fetchEndpoint('/v2/order/create', 'POST', data)

//订单支付信息
export const orderPayInfo = (data) => fetchEndpoint('/v2/order/pay-info', 'POST', data)

//索莱贝加入购物车
export const addPointsToCart = (data) => fetchEndpoint('/v2/cart/add-points-to-cart', 'POST', data)

//再来一单
export const orderRebuy = (data) => fetchEndpoint('/v2/order/rebuy', 'POST', data)

//万年历
export const permanentCalendar = () => fetchEndpoint('/v2/ecapi.permanent.calendar', 'POST')
//获取签到状态
export const signInStatus = () => fetchEndpoint('/v2/ecapi.signin.status', 'POST')

//执行签到
export const doSignIn = () => fetchEndpoint('/v2/ecapi.signin.do', 'POST')
//抽奖
export const luckyWheelDraw = () => fetchEndpoint('/v2/ecapi.lucky.wheel.draw', 'POST')
//每日任务
export const dailyTask = () => fetchEndpoint('/v2/ecapi.daily.task', 'POST')

//获取抽奖信息
export const luckyWheel = () => fetchEndpoint('/v2/ecapi.lucky.wheel', 'POST')
//徽章列表
export const badgeList = () => fetchEndpoint('/v2/ecapi.badge.list', 'POST')

// 积分信息
export const scoreGet = () => fetchEndpoint('/v2/ecapi.score.get', 'POST')

// 积分记录
export const pointsRecord = (data) => fetchEndpoint('/v2/ecapi.score.history.list', 'POST', data)

//积分兑换列表
export const scoreExchangeList = data => fetchEndpoint('/v2/ecapi.exchange.list', 'POST', data)

// 积分兑换记录
export const pointsRecordList = data =>	fetchEndpoint('/v2/ecapi.points.record', 'POST', data)	

// 地区列表（三级地址）
export const regionList = () => fetchEndpoint('/v2/ecapi.region.list', 'POST')

// 收货人列表
export const consigneeList = () => fetchEndpoint('/v2/ecapi.consignee.list', 'POST')

// 添加收货人
export const consigneeAdd = data => fetchEndpoint('/v2/ecapi.consignee.add', 'POST', data)

// 删除收货人
export const consigneeDelete = data => fetchEndpoint('/v2/ecapi.consignee.delete', 'POST', data)

// 修改收货人
export const consigneeUpdate = data => fetchEndpoint('/v2/ecapi.consignee.update', 'POST', data)

// 设置默认地址 ECM4.0
export const consigneeSetdefault = data => fetchEndpoint('/v2/ecapi.consignee.setDefault', 'POST', data)

// 获取默认地址
export const consigneeGet = () =>	fetchEndpoint('/v2/ecapi.default.address.get', 'POST')

// 获取套餐列表
export const packageList = (data) => fetchEndpoint('/v2/package/list', 'POST', data)

// 获取套餐详情
export const packageInfo = (data) => fetchEndpoint('/v2/package/info', 'POST', data)

// 获取商品库存
export const productStock = (data) => fetchEndpoint('/v2/product/stock', 'POST', data)

// 重选套餐产品
export const reselectPackageProduct = (data) => fetchEndpoint('/v2/package/reselect-package-product', 'POST', data)

//卡券列表
export const couponList = (data) => fetchEndpoint('/v2/ecapi.coupon.list', 'POST', data);

//浏览历史数据
export const historyList = (data) => fetchEndpoint('/v2/ecapi.history.list', 'POST', data)

// 注册字段
export const userProfileFields = () => fetchEndpoint('/v2/ecapi.user.profile.fields', 'POST')

// 获取用户资料
export const userProfileGet = () => fetchEndpoint('/v2/ecapi.user.profile.get', 'POST')

// 修改用户密码
export const userPasswordUpdate = (data) =>	fetchEndpoint('/v2/ecapi.user.password.update', 'POST', data)

//检测当前IP
export const getClientIp = () => fetchEndpoint('/v2/ecapi.user.ip', 'POST')	

// 修改用户资料
export const userProfileUpdate = (data) => fetchEndpoint('/v2/ecapi.user.profile.update', 'POST', data)

// 订单列表
export const getOrderList = (data) =>	fetchEndpoint('/v2/ecapi.order.list', 'POST', data)

// 订单详情
export const orderGet = data => fetchEndpoint('/v2/ecapi.order.get', 'POST', data)

// 确认收货
export const orderConfirm = data =>	fetchEndpoint('/v2/ecapi.order.confirm', 'POST', data)

// 获取退货原因
export const orderReasonList = () => fetchEndpoint('/v2/ecapi.order.reason.list', 'POST')

// 取消订单
export const orderCancel = (data) => fetchEndpoint('/v2/ecapi.order.cancel', 'POST', data)

// 评价订单
export const orderReview = (data) => fetchEndpoint('/v2/ecapi.order.review', 'POST', data)

// 获取优惠活动列表
export const activityList = () => fetchEndpoint('/v2/ecapi.activity.list', 'POST')

// 获取优惠活动列表
export const activityDetail = (data) => fetchEndpoint('/v2/ecapi.activity.get', 'POST', data)

//展会
export const exhibitionList = (data) => fetchEndpoint('/v2/ecapi.exhibit.get', 'POST', data)

//展会详情
export const exhibitDetail = (data) => fetchEndpoint('/v2/ecapi.exhibit.particulars', 'POST', data)

//校园行
export const campusTour = (data) => fetchEndpoint('/v2/ecapi.campustour.get', 'POST', data)

// ========== 开心抽奖（独立页 /luckyWheel，后续换新游戏接口时只改这里） ==========
// 获取抽奖信息：奖品列表 + 剩余次数
export const luckyWheelInfo = () => fetchEndpoint('/v2/lucky-wheel-info', 'POST')
// 验证唯一码（通过后才允许抽奖）
export const luckyWheelVerifyCode = (data) => fetchEndpoint('/v2/lucky-wheel-verify', 'POST', data)
//执行一次抽奖（带上已验证的唯一码）
export const luckyWheelDrawAction = (data) => fetchEndpoint('/v2/lucky_wheel_draw_action', 'POST', data)


// WEBPACK FOOTER //
// ./src/api/api.js